import { getCoordinates } from '@fusioncharts/utils/src/scale-utils/polar-util';

export default {
  'initial.dataset.radar': function () {
    return {
      'anchor.appearing': () => {
        return [{
          initialAttr: {
            opacity: 0
          },
          finalAttr: {
            opacity: 1
          },
          startEnd: {
            start: 0.5,
            end: 1
          },
          slot: 'plot'
        }];
      },
      'anchor.updating': () => {
        return [{
          initialAttr: {
            opacity: 0
          },
          finalAttr: {
            opacity: 1
          },
          slot: 'final'
        }];
      },
      'anchor.disappearing': () => {
        return [{
          finalAttr: {
            opacity: 0,
            'fill-opacity': 0,
            'stroke-opacity': 0
          },
          slot: 'final'
        }];
      },
      'line.appearing': (inputJSON) => {
        let dataset = inputJSON.component,
          xAxis = dataset.getFromEnv('xAxis'),
          yAxis = dataset.getFromEnv('yAxis'),
          catLen = xAxis.getTicksLen(),
          chartConfig = dataset.getFromEnv('chartConfig'),
          finalAttr = inputJSON.attr,
          value = (chartConfig.canvasTop + chartConfig.canvasHeight / 2),
          initialPath = [],
          i;
        for (i = 0; i < catLen; i++) {
          initialPath.push(i ? 'L' : 'M');
          initialPath.push(getCoordinates({
            radius: value,
            theta: 0
          }, xAxis).x);
          initialPath.push(yAxis.getPixel(0));
        }
        initialPath.push('Z');
        return [{
          initialAttr: {
            opacity: 0,
            path: initialPath
          },
          finalAttr: {
            opacity: 1,
            path: finalAttr.path
          },
          startEnd: {
            start: 0,
            end: 0.5
          },
          slot: 'middle'
        }];
      },
      'label.appearing': [{
        initialAttr: {
          opacity: 0
        },
        finalAttr: {
          opacity: 1
        },
        slot: 'final'
      }],
      '*': null
    };
  }
};
